import React from 'react'

import ExternalLink from '@components/shared/ExternalLink'
import NFIcon from '@components/shared/NFIcon'
import { FACEBOOK_LINK, INSTAGRAM_LINK, TWITTER_LINK } from '@utils/global'

const SocialSection: React.FC = () => {
  return (
    <div className="mr-2.5 p-2.5 flex flex-row sm:flex-col">
      <ExternalLink href={TWITTER_LINK}>
        <div className="w-[40px] h-[40px] flex items-center justify-center border-[1.5px] rounded-full">
          <NFIcon icon="twitter" className="text-xl" />
        </div>
      </ExternalLink>
      <ExternalLink href={FACEBOOK_LINK}>
        <div className="w-[40px] h-[40px] flex items-center justify-center border-[1.5px] rounded-full ml-5 sm:ml-0 sm:mt-5">
          <NFIcon icon="facebook" className="text-xl" />
        </div>
      </ExternalLink>
      <ExternalLink href={INSTAGRAM_LINK}>
        <div className="w-[40px] h-[40px] flex items-center justify-center border-[1.5px] rounded-full ml-5 sm:ml-0 sm:mt-5">
          <NFIcon icon="instagram" className="text-xl" />
        </div>
      </ExternalLink>
    </div>
  )
}

export default SocialSection
